// extracted by mini-css-extract-plugin
export default {"cardTop":"EventDetails_cardTop__1nx4i"};